angular.module( 'acme.view.application.orders.requests.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.dataGrid',
  'acme.view.application.dataGrid.controllers',
  'acme.view.application.orders.requests.list.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var ordersRequestsList = {
        name: 'application.orders.requests.list',
        url: '/list',
        views: {
          "subview-main": {
            controller: 'OrdersRequestsListController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/orders/requests/list/list.tpl.html'
          }
        },
        data: {
          pageTitle: 'Order Requests list',
          permissions: ['ORDER_REQUEST_VIEW'],
          enablePreferences: true
        }
      };

    $stateProvider
      .state(ordersRequestsList);
});
